import { jsx as o } from "react/jsx-runtime";
import { forwardRef as w } from "react";
const p = w(({
  stroke: h = "currentColor",
  strokeWidth: t = "2",
  strokeLinecap: n = "round",
  strokeLinejoin: e = "round",
  fill: a = "none",
  size: r = "24",
  viewBox: d = "0 0 24 24",
  style: l = null,
  ...u
}, v) => /* @__PURE__ */ o(
  "svg",
  {
    ref: v,
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: d,
    fill: a,
    stroke: h,
    strokeWidth: t,
    strokeLinecap: n,
    strokeLinejoin: e,
    style: l,
    ...u,
    children: /* @__PURE__ */ o("path", { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" })
  }
));
export {
  p as default
};
